import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router-dom';

import { AgreementPartyReadModel } from '@client/api';
import { isDefinedString, TableCell, TableRow, Text } from '@client/toolkit';
import { CompaniesPaths } from '../../../../companies/companies.router';
import { useTenants } from '../../../../../hooks/useTenants/useTenants';
import { TenantSelectionEnum } from '../../../../../redux';

type AgreementPartyItemProps = {
  agreementParty?: AgreementPartyReadModel;
  isFetching?: boolean;
};

export function AgreementPartyItem({ agreementParty, isFetching }: AgreementPartyItemProps) {
  const { t: tType } = useTranslation('type');
  const { selectedTenant } = useTenants();
  const currentTenantId = selectedTenant && selectedTenant !== TenantSelectionEnum.All ? selectedTenant.id : null;

  return (
    <TableRow verticalAlign="middle">
      <TableCell loading={isFetching}>
        <Text as="div" isEmpty={!isDefinedString(agreementParty?.stakeholder.name)}>
          {agreementParty?.stakeholder?.id === currentTenantId ? (
            <Link
              to="/profile"
              className="hover:text-brand-primary transition-colors"
            >
              <strong className="whitespace-nowrap">{agreementParty.stakeholder.name}</strong>
            </Link>
          ) : agreementParty?.stakeholder?.companyId ? (
            <Link
              to={generatePath(CompaniesPaths.Company, { id: agreementParty.stakeholder.companyId })}
              className="hover:text-brand-primary transition-colors"
            >
              <strong className="whitespace-nowrap">{agreementParty.stakeholder.name}</strong>
            </Link>
          ) : (
            <strong className="whitespace-nowrap">{agreementParty?.stakeholder.name}</strong>
          )}
        </Text>
      </TableCell>

      <TableCell loading={isFetching}>
        <Text as="div" isEmpty={!isDefinedString(agreementParty?.type)}>
          {tType(`RelationshipType.${agreementParty?.type}`)}
        </Text>
      </TableCell>

      <TableCell loading={isFetching}>
        <Text as="div" isEmpty={!agreementParty?.representative?.name}>
          {agreementParty?.representative?.name ?? '—'}
        </Text>
      </TableCell>

      <TableCell loading={isFetching}>
        <Text as="div" isEmpty={!agreementParty?.representative?.email}>
          {agreementParty?.representative?.email ?? '—'}
        </Text>
      </TableCell>

      <TableCell loading={isFetching}>
        <Text as="div" isEmpty={!agreementParty?.representative?.phone}>
          {agreementParty?.representative?.phone ?? '—'}
        </Text>
      </TableCell>
    </TableRow>
  );
}
